document.addEventListener("DOMContentLoaded", function () {
    if (window.innerWidth > 768) return;

    const firstColumn = document.querySelector(".historia .wp-block-column:first-child");
    const footer = document.querySelector("footer");
    if (!firstColumn || !footer) return;

    const dropdownContainer = document.createElement("div");
    dropdownContainer.id = "timeline-dropdown";
    dropdownContainer.classList.add("timeline-dropdown");

    const dropdownButton = document.createElement("button");
    dropdownButton.id = "timeline-button";
    dropdownButton.classList.add("timeline-button");
	dropdownButton.innerHTML = hl_menu_mobile_sobre_data.browseHistory;

    const dropdownMenu = document.createElement("ul");
    dropdownMenu.id = "timeline-menu";
    dropdownMenu.classList.add("timeline-menu");

    firstColumn.querySelectorAll("a").forEach((link) => {
        const menuItem = document.createElement("li");
        menuItem.classList.add("timeline-menu-item");

        const menuLink = document.createElement("a");
        menuLink.href = link.href;
        menuLink.textContent = link.textContent;
        menuLink.classList.add("timeline-menu-link");

        menuItem.appendChild(menuLink);
        dropdownMenu.appendChild(menuItem);
    });

    dropdownContainer.appendChild(dropdownButton);
    dropdownContainer.appendChild(dropdownMenu);
    firstColumn.parentNode.insertBefore(dropdownContainer, firstColumn);

    dropdownButton.addEventListener("click", function () {
        const isOpen = dropdownMenu.style.display === "block";

        dropdownMenu.style.display = isOpen ? "none" : "block";
        dropdownButton.classList.toggle("active", !isOpen);
    });

    document.addEventListener("click", function (event) {
        if (!dropdownContainer.contains(event.target)) {
            dropdownMenu.style.display = "none";
            dropdownButton.classList.remove("active");
        }
    });

	function checkMenuPosition() {
		const footerTop = footer.getBoundingClientRect().top;
		const dropdownHeight = dropdownContainer.offsetHeight;
		const windowHeight = window.innerHeight;

		if (footerTop <= windowHeight) {
			dropdownContainer.style.position = "absolute";
			dropdownContainer.style.bottom = `${footer.offsetHeight + 20}px`;
		} else {
			dropdownContainer.style.position = "fixed";
			dropdownContainer.style.bottom = "10px";
		}
	}

    window.addEventListener("scroll", checkMenuPosition);
    checkMenuPosition();
});


